
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 6.5v1H4V18h16V7.5H9v-1h10.5A1.501 1.501 0 0121 8v10h2.25a.75.75 0 01.75.75v.75a3.011 3.011 0 01-2.996 3H2.996c-.206 0-.408-.03-.603-.084C1.031 22.036.003 20.944 0 19.5v-.75A.75.75 0 01.75 18H3V8a1.501 1.501 0 011.5-1.5H9zM23 19c0 1.5-1.174 2.498-2 2.5H3c-.826-.002-2-1-2-2.5h22z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.457 14.298a.6.6 0 01-.957-.483V12h-3A1.48 1.48 0 019 10.5v-8c0-.797.656-1.5 1.5-1.5h12c.797 0 1.5.703 1.5 1.5v8c0 .844-.703 1.5-1.5 1.5H17.578l-.328.234-2.793 2.064z","fill":"#00DCF7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.375 5.5h7.25A.375.375 0 0019 5.125v-.75A.375.375 0 0018.626 4h-7.25a.376.376 0 00-.376.375v.75c0 .207.17.375.375.375zM16 8.125v-.75A.375.375 0 0015.625 7h-4.25a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h4.25A.375.375 0 0016 8.125z","fill":"#fff"}})])
          )
        }
      }
    